import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-lg-8 mx-auto text-center mb-5">
          <h1 className="display-4 fw-bold">About Sterling Tax Solutions</h1>
          <p className="lead">
            Providing expert tax services with integrity and excellence
          </p>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <h2 className="mb-4">Our Story</h2>
              <p>
                Sterling Tax Solutions was founded with a clear mission: to provide individuals and businesses 
                with expert tax services that maximize savings while ensuring full compliance with tax laws 
                and regulations. What began as a small practice has grown into a trusted tax firm serving 
                clients throughout the Greater Toronto Area, Ontario.
              </p>
              <p>
                Our team consists of qualified tax professionals who bring years of experience and 
                specialized knowledge to every client engagement. We pride ourselves on staying current 
                with the latest tax laws, regulations, and strategies to provide our clients with 
                the most effective solutions for their unique tax situations.
              </p>
              <p>
                At Sterling Tax Solutions, we believe that tax services should be accessible, 
                understandable, and personalized. We take the time to understand each client's 
                specific needs and concerns, providing clear communication and guidance throughout 
                the tax preparation and planning process.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <h2 className="mb-4">Our Mission</h2>
              <p>
                Our mission at Sterling Tax Solutions is to empower our clients with professional 
                tax expertise and personalized service that maximizes their financial well-being 
                while ensuring compliance with all applicable tax laws.
              </p>
              <p>
                We are committed to providing accessible, clear, and effective tax solutions that 
                address each client's unique needs and objectives, delivered with the highest 
                standards of integrity, professionalism, and client care.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <h2 className="mb-4">Our Values</h2>
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="p-3 border-start border-4 border-primary">
                    <h5>Integrity</h5>
                    <p>
                      We uphold the highest ethical standards in all our work, ensuring honesty and 
                      transparency in every client interaction.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border-start border-4 border-primary">
                    <h5>Excellence</h5>
                    <p>
                      We are committed to delivering exceptional service and accurate tax solutions 
                      that exceed our clients' expectations.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border-start border-4 border-primary">
                    <h5>Client Focus</h5>
                    <p>
                      We prioritize understanding each client's unique needs to provide personalized 
                      and relevant tax solutions.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 border-start border-4 border-primary">
                    <h5>Innovation</h5>
                    <p>
                      We continuously seek new strategies and approaches to optimize tax outcomes 
                      while staying current with evolving tax regulations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-10 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 p-md-5">
              <h2 className="mb-4">Our Team</h2>
              <p>
                Sterling Tax Solutions is powered by a team of dedicated tax professionals who are 
                committed to providing expert guidance and support to our clients. Our team members 
                hold relevant qualifications and certifications, including Chartered Professional 
                Accountant (CPA) designations, and continuously pursue professional development to 
                stay at the forefront of tax expertise.
              </p>
              <p>
                With diverse backgrounds and areas of specialization, our team is equipped to 
                handle a wide range of tax matters, from personal income tax preparation to 
                complex tax planning strategies for businesses and high-net-worth individuals.
              </p>
              <p>
                We work collaboratively to leverage our collective knowledge and experience, 
                ensuring that each client receives comprehensive and well-informed tax solutions 
                tailored to their specific needs and goals.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-10 mx-auto">
          <div className="card sterling-bg text-white text-center">
            <div className="card-body p-5">
              <h2 className="mb-3">Ready to work with us?</h2>
              <p className="mb-4">
                Get in touch today to learn more about our services and how we can help you with your tax needs.
              </p>
              <Link to="/appointments" className="btn btn-light me-2">Book an Appointment</Link>
              <Link to="/contact" className="btn btn-outline-light">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 